export const SET_MAINTENIS = (state, payload) => {
    state.main_tenis = payload
}

export const SET_NOTIF = (state, notif) => {
    state.notif = {
        msg: notif.msg,
        type: notif.type
    }
}

export const SET_PESANS = (state, payload) => {
    state.pesans = payload
}

export const SET_PESANS_ALL = (state, payload) => {
    state.pesansAll = payload
}


export const UNSET_NOTIF = (state, notif) => {
    state.notif = {
        msg: null,
        type: null
    }
}

export const SET_SQL = (state, payload) => {
    state.sql = payload;
}

export const UNSET_SQL = (state) => {
    state.sql = null;
}


export const SET_OVERLAY = (state, overlay) => {
    state.overlay = overlay
}

export const SET_OVERLAY_BG = (state, overlay_bg) => {
    state.overlay_bg = overlay_bg
}

export const SET_ANCHOR = (state, payload) => {
    state.anchor = payload
}

export const SET_DALAM_MUTASI = (state, payload) => {
    state.dalam_mutasi = payload;
}

export const UNSET_DALAM_MUTASI = (state) => {
    state.dalam_mutasi = null;
}

export const SET_DALAM_KELUAR = (state, payload) => {
    state.dalam_keluar = payload;
}

export const UNSET_DALAM_KELUAR = (state) => {
    state.dalam_keluar = null;
}

export const SET_DINAS_UMUM = (state, payload) => {
    state.dinasUmum = payload;
}

// export const SET_DINAS_UMUM = (state, payload) => {
//     state.dinasUmum = payload;
// }

export const SET_APP_INFO = (state, payload) => {
    state.app_info = payload;
}

export const SET_KUNCI_PENGINPUTAN = (state, payload) => {
    state.kunci_penginputan = payload;
}

export const UNSET_KUNCI_PENGINPUTAN = (state) => {
    state.kunci_penginputan = false;
}